import React, { useState, useEffect, useRef} from 'react';
import ChatMessage from './ChatMessage';
import ChatInput from './ChatInput';
import  './ChatRoom.css';
import Rip from './Rip.js';
import Feedback from './Feedback.js';
import Pause from './Pause.js';
import * as d3sc from 'd3-scale';

const ChatRoom = ({ roomId, u_id, username, mapName, roomType, 
                    socket, mmNodes, startDate,
                    server_host, scrollMessages, domainCorrections,
                    lastLiveMessageId, setLastLiveMessageId, 
                    pointed_message, messages, setMessages,
                    minThreshold=0.99, is_owner=false, 
                    is_coach=false, isMobile=false}) => {
  const [description, setDescription] = useState('');
  const [leadedMove, setLeadedMove] = useState(false)
  const [listUsers, setListUsers] = useState({})
  const [domain_corrections, setDomain_corrections] = useState(new Map())
  const domain_corrections_ref = useRef(domain_corrections)
  const [parentMessage, setParentMessage] = useState(undefined); // if conversation created from an other conversation
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [currentRoom, setCurrentRoom] = useState(roomId)
  const [uid, setUid] = useState(u_id)
  const [channel, setChannel] = useState(socket)
  const endMessagesRef = useRef(null);
  const [loaded, setLoaded] = useState(false)
  const [isCoachingRoom, setIsCoachingRoom] = useState(false)
  const [toScroll, setToScroll] = useState(true)
  const [speaking, setSpeaking] = useState('  ')

  const mapRef = useRef(messages);
  const roomRef = useRef(currentRoom)
  const overThresholdMessages = useRef([])
  const colorScaleRef = useRef(null)

  let protocol = process.env.REACT_APP_PROTOCOL

  
  useEffect(() => {
      const dMessages = selectMessagesUpTo(pointed_message)
      setDisplayedMessages(dMessages.slice(-100))
      setLoaded(false)
  }, []);


  useEffect(() => {
    // Simulate loading of items
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 300); // Simulating a delay for loading items
    return () => clearTimeout(timeout);
  }, [displayedMessages]);

  function formatTimestamp(timestamp) {
    const today = new Date();
    const date = new Date(timestamp / 1000 * 1000)
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      // Aujourd'hui
      return `${date.getHours()}:${date.getMinutes()}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
      // Hier
      return `Hier ${date.getHours()}:${date.getMinutes()}`;
    } else {
      // Jour antérieur à hier
      return `${date.getDate()}/${date.getMonth() + 1} ${date.getHours()}:${date.getMinutes()}`;
    }
  }


function sup_match_domain(id, matches_str){
  if (domain_corrections_ref.current[id]) {
      if (domain_corrections_ref.current[id].strength > minThreshold) {
        return true
      } else {
        return false
      }
  }

  if (matches_str === undefined || matches_str.length === 0)
    return ''
  var matches = []
  // console.log(Object.prototype.toString.call(matches_str))
  // console.log(typeof matches_str)
  try { // new matching format
    matches_str.map((m) => {
      const sim = JSON.parse(m)
      matches.push(sim)
      return
    })
  } catch { // old matching format
    try {
      matches = JSON.parse(matches_str)
    } catch {
      matches = matches_str
    }

  }
 for (var k in matches) {
    let val = matches[k]
    
    if (val.pondered_similarity === undefined) {  // compat ascendante, ignore
          continue
    } else {
        if (val.pondered_similarity > minThreshold) {
          return true
        }
      }
    }
 return false
}

  function selectMessagesUpTo(m, cur_messages=messages) {
      const res = []
      overThresholdMessages.current = []
      colorScaleRef.current = null
      const sortedMessageEntries = Array.from(cur_messages.entries()).sort((a, b) => a[0] - b[0])
      if ((m === null) || (m === '') || (m === undefined)){ // no limit in the display
        sortedMessageEntries.map((mm) => {
          if (mm[1].roomId == currentRoom && (startDate == null || mm[1].id >= startDate)) {
            mm[1].current_target = false
            res.push(mm[1])
            if (sup_match_domain(mm[0], mm[1].matched_domains)) {
              overThresholdMessages.current.push(mm[0])
            }
          }
        })
        if (res.length > 0) {
          const last = res.pop()
          last.current_target = true
          if (setLastLiveMessageId) {
            setLastLiveMessageId(last.id)
          }
          res.push(last)
        }
        colorScaleRef.current = d3sc.scaleLinear()
          .domain([0, overThresholdMessages.current.length - 1]) // index des étapes
          .range([ "#f9e105ff", "#0ceaf9ff"]);   // début et fin du gradient
        return res
      }
  
      var top = false
      var nb_more = 2
      let id_toCheckWith = m
      sortedMessageEntries.map((mm) => {
        if (((m === undefined) || (id_toCheckWith >= mm[1].id))
          && (startDate == null || startDate <= mm[1].id)) {
          mm[1].current_target = false
          res.push(mm[1])
          if (sup_match_domain(mm[0], mm[1].matched_domains)) {
              overThresholdMessages.current.push(mm[0])
          }
          if (m !== undefined) {
            if (id_toCheckWith === mm[1].id) {
              mm[1].current_target = true
              top = true
            }
          }
        } else if (top && nb_more > 0) {
              nb_more -= 1
              mm[1].current_target = false
              res.push(mm[1])
        }
        return null // everything done through update
      });
        
        
      colorScaleRef.current = d3sc.scaleLinear()
        .domain([0, overThresholdMessages.current.length - 1]) // index des étapes
        .range([ "#f9e105ff", "#0ceaf9ff"]);   // début et fin du gradient

      return res;
    }


useEffect(() => {
      const dMessages = selectMessagesUpTo(pointed_message)
      setDisplayedMessages(dMessages.slice(-100))
      setLoaded(false)
  }, [pointed_message, messages, domain_corrections, startDate, minThreshold]);

  channel.on('match corrections', (corrections, roomId) => {
      console.log('got domain corrections')
      if (roomRef.current != roomId) 
        return
      corrections.map((corr, i) => {
         domain_corrections_ref.current[corr.message_id] = corr
         })
        setDomain_corrections(new Map(domain_corrections_ref.current))
    });

  useEffect(() => {
    // Only scroll into view after items are loaded
    if (loaded && toScroll && endMessagesRef.current) {
      endMessagesRef.current.scrollIntoView({ block: "start",  behavior: 'smooth' });
    }
  }, [loaded, toScroll, messages, pointed_message, startDate]);


  channel.on('room joined', (roomId, description, parent_message, 
    point_message, user, mmap, is_owner, is_coach, is_coaching) => {
    if (user === 'leaded move'){
      setLeadedMove(true)
    } else {
      setLeadedMove(false)
    }
    setIsCoachingRoom(is_coaching)
    setParentMessage(parent_message)
    scrollMessages(point_message)
    if (currentRoom !== roomId) {
      setMessages(new Map())
      setDisplayedMessages([])
      setDomain_corrections(new Map())
      domain_corrections_ref.current = new Map()
    }
  if ((user === uid) || (user === 'leaded move')){
      setCurrentRoom(roomId)
      roomRef.current = roomId
      selectMessagesUpTo(pointed_message)
      setDescription(description)
    }
    setToScroll(true);
});

  channel.on('chat message', (mess) => {
    const message = JSON.parse(mess)
    if (message && message.roomId === currentRoom) {
               // messages.push(message)
            if (domain_corrections_ref.current[message.id]){
              message.correction = domain_corrections[message.id]
            }
               mapRef.current.set(message.id, message)
               setMessages(new Map(mapRef.current))
        }
  });


 channel.on('init room messages' , (requesting_room, requesting_uid, mss) => {
  if ((requesting_room === currentRoom) && ((requesting_uid === uid) || (requesting_uid === 'leaded move'))){
    const ms = JSON.parse(mss)
    ms.map((m) => {
      if (m.roomId == roomRef.current) {
            if (domain_corrections_ref.current[m.id]){
              m.correction = domain_corrections_ref.current[m.id]
            }
        mapRef.current.set(m.id, m)
      }
    })
    setMessages(mapRef.current)
    const dMessages = selectMessagesUpTo(pointed_message, mapRef.current)
    setDisplayedMessages(dMessages.slice(-100))
  }
  })

 channel.on('update room users' , (requesting_room, requesting_uid, uss) => {
  if ((requesting_room === currentRoom) && ((requesting_uid === uid) || (requesting_uid === 'leaded move'))){
    const us = JSON.parse(uss)
    const users = {}
    us.map((u) => {
      // if (u.id !== uid)
        users[u.id] = u
      })
    setListUsers(users)
  }
  })



    channel.on('domain matches', (matching_messages,  matched_room) => {
      if (matched_room === currentRoom) {
          const matched_messages = JSON.parse(matching_messages)
          matched_messages.map((message) => {
            if (message.matched_domains instanceof String) {
                  message.matched_domains = JSON.parse(message.matched_domains)
            }
            if (domain_corrections[message.id]){
              message.correction = domain_corrections[message.id]
            }
            mapRef.current.set(message.id, message)
          })
          setMessages(mapRef.current)

        }
     });
    
    channel.on('update message content', (st_message) => {
      const message =  JSON.parse(st_message)
      if (message.roomId === currentRoom) {
        setMessages((prevMessages) => {
            if (domain_corrections_ref.current[message.id]){
              message.correction = domain_corrections_ref.current[message.id]
            }
            mapRef.current.set(message.id, message)
            setMessages(mapRef.current)
          });
      }
    });

  useEffect(() => {

    return () => {
      channel.off('message');
    };
  }, [currentRoom, channel, uid, toScroll, leadedMove, domain_corrections]);

  var shown_stamps = []


  const sendMessage = (contenu) => {
    const orig_room = currentRoom
    const message = { username, contenu, orig_room, uid };
    channel.emit('chat message', message)
  };

  const sendVoiceMessage = (contenu, blobs) => {
    const orig_room = currentRoom
    const message = { username, contenu, orig_room, uid };
    message['sounds'] = blobs
    channel.emit('voice message', message)
  };

  function switchToOrigin() {
    console.log('switching to message ' + parentMessage)
    const m_id = parentMessage.id
    channel.emit('switch parent', {parentMessage, currentRoom, uid})
  }


  function returnToLive() {
    scrollMessages(null)
  }

  function toggleFullScreen() {
      const elem = document.getElementById('chatroom');
    if (!document.fullscreenElement) {
        // Enter full screen
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { // Firefox
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { // IE/Edge
            elem.msRequestFullscreen();
        }
    } else {
        // Exit full screen
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen();
        }
    }
}

function getColorGradient(value, max = 50) {
  // gradient from 85, 255, 85 to 255, 85, 85
    value = Math.min(Math.max(value, 0), max);
    let ratio = value / max;
    

    let r = 85 + Math.round(170 * ratio);
    let g = 85 + Math.round(170 * (1 - ratio));
    let b = 90;
    return `rgb(${r},${g},${b})`;
}


function removeAfterLastUnderscore(str) {
    const lastIndex = str.lastIndexOf('_');
    return lastIndex !== -1 ? str.substring(0, lastIndex) : str;
}


function finishesWith(str, suffix) {
    return str.slice(-suffix.length) === suffix;
}
function beginsWith(str, prefix) {
    return str.slice(0, prefix.length) === prefix;
}


function compute_message_polarity(message){
  /*
  for (let key in time_pondered_similarities) {
    delete time_pondered_similarities[key][message_id];
  }
    */
  if (domain_corrections_ref.current[message.id]){
      var correction = domain_corrections_ref.current[message.id]
      if (correction && mmNodes) {
        var target_node = mmNodes.find((cn) => {
          if (cn.id === 'observations_local_Nouvelles_diverses_Météo_Journal_de_bord_1748420941.427597'){
            // console.log('debug point')
          }
          return removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(correction.target_node)
        })
        if (target_node) {
          if (target_node.negative === 'true') {
            return 'negative'
          } else {
            return 'positive'
          }
        }
      }
      }


  if (message.matched_domains === undefined || message.matched_domains.length === 0)
    return 'positive'
  if (message.polarity) {
    return message.polarity
  }
  var time_pondered_similarities = {}
  var polarities = {}
  var matches = []
  // console.log(Object.prototype.toString.call(matches_str))
  // console.log(typeof matches_str)
  try { // new matching format
    message.matched_domains.map((m) => {
      const sim = JSON.parse(m)
      matches.push(sim)
      return
    })
  } catch { // old matching format
    try {
      matches = JSON.parse(message.matched_domains)
    } catch {
      matches = message.matched_domains
    }

  }
 var max = 0.3
 var max_domain = ''
 for (var k in matches) {
    let val = matches[k]
    if (val.similarity === undefined) {  // compat ascendante, temporaire
      if (val.concept) {
        continue
      }
        if (val[0] >= max) {
          max = val[0]
          max_domain = val[1]
        }
    } else {
      let time_factor = 1  // to be refine by the difference between now and the treated utterance
      try {
        const ts = val["utterance_id"].split("_").splice(-1)
        let start_ts =  Date.now()
        if (pointed_message)
          start_ts = parseFloat(pointed_message)
        time_factor = (start_ts / parseFloat(ts)) ** 0.01
      } catch {}
      const pondered_similarity = val.pondered_similarity
      const time_pondered_similarity = pondered_similarity / time_factor
      time_pondered_similarities[val.domain] = time_pondered_similarity

      if (time_pondered_similarity >= max) {
        max = time_pondered_similarity
        max_domain = val.domain
      }

      const items = JSON.parse(val['items'])
      var max_item_sim = 0
      var max_item_sim_id = undefined
      for (var i in items) {
        const item = items[i]
        // console.log('updating quality for ' + item)
        const psim = ((pondered_similarity * item.pondered_similarity) ** 0.5)/ time_factor
        time_pondered_similarities[item.id] = psim
        polarities[removeAfterLastUnderscore(item.id)] = 'positive'
        const tests = JSON.parse(item.similarity_tests)
        var max_test_sim = 0
        var max_test_sim_id = undefined
        if (mmNodes != undefined) {
          for (var t in tests) {
            const test = tests[t]
            const source = mmNodes.find((cn) => removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(test.id))
            const psim = ((pondered_similarity * test.pondered_similarity * item.pondered_similarity ) ** 0.33) / time_factor
            time_pondered_similarities[test.id] = psim

            var polarity = 'positive'
            if ((source !== undefined) && (source.negative === 'true')) {
              polarity = 'negative'
            }
            if (test.pondered_similarity > max_test_sim) {
              max_test_sim = test.pondered_similarity
              max_test_sim_id = test.id
            }
            polarities[removeAfterLastUnderscore(test.id)] = polarity
            polarities[removeAfterLastUnderscore(item.id)] = polarity
            polarities[removeAfterLastUnderscore(val.domain)] = polarity
            var max_check_sim = 0
            var max_check_sim_id = undefined

            const checks = JSON.parse(test.similarity_checks)

            for (var c in checks) {
              const check = checks[c]
              var check_polarity = polarity
              if (beginsWith(check.id, 'faible')) {
                console.log('debug point')
              }
              if (polarity === 'positive') {
                const source = mmNodes.find((cn) => removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(check.id))
                if ((source !== undefined) && (source.negative === 'true')) {
                  check_polarity = 'negative'
                }
              } else {
                check_polarity = 'negative'
              }
              if (check.pondered_similarity > max_check_sim) {
                max_check_sim = check.pondered_similarity
                max_check_sim_id = check.id
              }
  
              const psim = ((pondered_similarity * check.pondered_similarity * test.pondered_similarity * item.pondered_similarity ) ** 0.25)/ time_factor
              time_pondered_similarities[check.id] = psim
              polarities[removeAfterLastUnderscore(check.id)] = check_polarity
            }
            if ((polarity === 'positive') && (max_check_sim_id != undefined)){
              polarities[removeAfterLastUnderscore(test.id)] = polarities[removeAfterLastUnderscore(max_check_sim_id)]
            }
          }
        }  
        if (max_test_sim_id != undefined) {
          polarities[removeAfterLastUnderscore(item.id)] = polarities[removeAfterLastUnderscore(max_test_sim_id)]
        }
        if (item.pondered_similarity > max_item_sim) {
          max_item_sim = item.pondered_similarity
          max_item_sim_id = item.id
        }
      }
      if (max_item_sim_id != undefined) {
        polarities[removeAfterLastUnderscore(val.domain)] = polarities[removeAfterLastUnderscore(max_item_sim_id)]
      } else {
        polarities[removeAfterLastUnderscore(val.domain)] = 'positive'
      }
  }

  }
 return polarities[removeAfterLastUnderscore(max_domain)]
}



const invite = (user) =>  {
  socket.emit('log immediate invite', uid, roomId, user.lease_id, user.id)
}

const reInvite = (user) =>  { // will probably have to differentiate the message on the server, to be done later
  socket.emit('log immediate invite', uid, roomId, user.lease_id, user.id)
}


  if (currentRoom !== undefined) {
      return (
      <div className="chatroom" id="chatroom"  key={currentRoom}>
        <div className="chatroom-title">     
          <p title={description}>{currentRoom} - {roomType} ({mapName})</p>
           {(parentMessage != null) && <button onClick={switchToOrigin}> &lt;- </button>}
          <Pause channel={channel} server_host={server_host} uid={uid} username={username} roomId={currentRoom} is_coaching_room={isCoachingRoom} is_owner={is_owner} is_coach={is_coach}/>
          <Rip channel={channel} server_host={server_host} uid={uid} username={username} roomId={currentRoom} is_coaching_room={isCoachingRoom} is_owner={is_owner} is_coach={is_coach}/>
          <Feedback channel={channel} server_host={server_host} uid={uid} username={username} roomId={currentRoom} is_coaching_room={isCoachingRoom} is_owner={is_owner} is_coach={is_coach}/>
          {/*(!document.fullscreenElement && ! isMobile) && <button onClick={toggleFullScreen}>plein écran</button>*/}
          {(pointed_message !== undefined) && (pointed_message != null) &&  (pointed_message != '') && <button class='returnToLiveButton' title='Inspection des messages avant cette date. Click pour retourner à la discussion' onClick={returnToLive}>{formatTimestamp(pointed_message)}</button>}
        </div> 

      <div className="chat-messages">
        {displayedMessages.map((msg) => {
           if (msg.roomId === roomRef.current) {
              const is = shown_stamps.findIndex(s => s === msg.id)
              if (is === -1) {
//                shown_stamps.push(msg.id)
                  const dom_correction = domain_corrections_ref.current[msg.id]
                  let d_correction = ''
                  let d_polarity = 'positive'
                  if (dom_correction){
                    d_correction = dom_correction.nickName
                    // d_polarity = dom_correction.polarity
                    d_polarity = compute_message_polarity(msg)

                  } else {
                    d_polarity = compute_message_polarity(msg)
                  }

                return(
                    <ChatMessage content={msg.message ? msg.message : msg.contenu} isSelf={msg.uid === uid}
                                 isCurrentTarget={msg.current_target} origin={msg.origin} 
                                 stamp={msg.id} scrollMessages={scrollMessages}
                                 formatTimestamp={formatTimestamp}
                                 domain_correction={d_correction} 
                                 domain_polarity={d_polarity} 
                                 domain_matches={msg.matched_domains} 
                                 speaker= {msg.speaker}
                                 overThresholdMessages={overThresholdMessages.current} 
                                 colorScale={colorScaleRef.current}/>
                                 
                )
              }
           }
           return null
        })}
        <div id='chat-messages-end' ref={endMessagesRef}/>

        </div>
          <p className="users">
            {/*}
              <span class="user online">Alice</span>
              <span class="user offline phone-on">Bob</span>
              <span class="user online mic-off">Charlie</span>
              <span class="user online phone-off">Pat</span>*/}
            {Object.entries(listUsers).map(([key, user]) => (
              <span key={key} style={{
                  backgroundColor: getColorGradient(user.duration_without_activity),
                  cursor: user.online ? 'default' : 'pointer'
                }}
                onClick={user.online ? () => reInvite(user) : () => invite(user)}
                className={`user ${user.online? 'online' : 'offline'} ${user.phone}`} 
                        >{user.pseudo}</span>
            ))}
              <span key='speakingGuy' className='speakingOnPhone'>{speaking}</span>

          </p>

      <ChatInput key='chatInput' channel={channel} room={currentRoom} uid={uid}
            username={username} sendMessage={sendMessage} setSpeaking={setSpeaking}
            server_host={server_host} sendVoiceMessage={sendVoiceMessage} isVisible={pointed_message===undefined || pointed_message === null || pointed_message === ''} />

      </div>
   ) 
  } else { 
    return (
      <div className="undef_chatroom">
      <h2>Bienvenue, entrez dans une des conversations proposées</h2>
     </div>
   ) 
  }
};

export default ChatRoom;